import React, { useEffect, useRef, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import { IoAlertCircleOutline, IoCheckmarkCircleOutline } from 'react-icons/io5'

import AlertCSS from './alert.module.css'

const EXIT_DURATION_MS = 300

// alert puede pasar a null/undefined (para ocultarse) mientras el componente
// sigue montado un instante más para poder animar la salida antes de
// desaparecer del todo.
const CustomAlert = ({ alert }) => {
  const [visible, setVisible] = useState(false)
  const [renderedAlert, setRenderedAlert] = useState(alert)
  const hideTimeoutRef = useRef(null)

  useEffect(() => {
    clearTimeout(hideTimeoutRef.current)

    if (alert) {
      setRenderedAlert(alert)
      const frame = requestAnimationFrame(() => setVisible(true))
      return () => cancelAnimationFrame(frame)
    }

    setVisible(false)
    hideTimeoutRef.current = setTimeout(() => {
      setRenderedAlert(null)
    }, EXIT_DURATION_MS)

    return () => clearTimeout(hideTimeoutRef.current)
  }, [alert])

  if (!renderedAlert) return null

  return (
    <Alert
      className={`${AlertCSS.alert} ${visible ? AlertCSS.alertVisible : ''} ${
        renderedAlert.variant === 'danger'
          ? AlertCSS.alertDanger
          : AlertCSS.alertSuccess
      }`}
      variant={renderedAlert.variant}
    >
      <div className={AlertCSS.icon}>
        {renderedAlert.variant === 'danger' ? (
          <IoAlertCircleOutline />
        ) : (
          <IoCheckmarkCircleOutline />
        )}
      </div>
      <p>{renderedAlert.msg}</p>
    </Alert>
  )
}

export default CustomAlert
